import React from "react";
import CyberBackground from "./CyberBackground";
import { Reveal } from "./Reveal";

export default function PageHero({ tag, title, desc }) {
  return (
    <section className="relative pt-32 pb-14 overflow-hidden">
      <div className="absolute inset-0 rq-grid-bg opacity-50" />
      <div className="absolute inset-0 opacity-70">
        <CyberBackground />
      </div>
      <div
        className="absolute -top-32 left-1/2 -translate-x-1/2 h-[420px] w-[420px] rounded-full blur-[130px] opacity-25"
        style={{ background: "radial-gradient(circle,#2ee66e,transparent 70%)" }}
      />
      <div className="rq-container relative z-10 text-center max-w-3xl">
        <Reveal>
          <span className="rq-tag justify-center">
            <span className="h-px w-6 bg-[color:var(--rq-green)] inline-block" />
            {tag}
          </span>
        </Reveal>
        <Reveal delay={90}>
          <h1 className="font-display mt-4 text-4xl md:text-5xl lg:text-[56px] font-bold text-white leading-tight">
            {title}
          </h1>
        </Reveal>
        {desc && (
          <Reveal delay={170}>
            <p className="mt-6 text-base md:text-lg leading-relaxed text-[color:var(--rq-muted)]">{desc}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
